  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : null;
  }
async function getSimilarProducts(userId, productId, eventType) {
  const sessionId = getCookie('_shopify_y');
  
  try {
    const response = await fetch(FASHIONAI_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-FashionAI-APP-Token': FASHIONAI_TOKEN
      },
      body: JSON.stringify({
        userId: userId ? userId.toString() : null,
        sessionId: sessionId,
        eventType: eventType,
        data: { id: productId.toString() }
      })
    });
    if (!response.ok) {
      throw new Error(`Falha na requisição da API com status ${response.status}`);

    }
    const data = await response.json();
    return getProducts(data);
  } catch (error) {
    console.error("Erro ao buscar produtos similares:", error);
    return [];
  }
}

async function getProducts(similarResponse) {
  const ids = Array.isArray(similarResponse.products)
    ? similarResponse.products.filter(id => id != null)
    : [];
  if (ids.length === 0) return [];

  const gidIds = ids.map(id => `gid://shopify/Product/${id}`)

  const query = `
    query getProductsByIds($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          metafield(key: "percentage", namespace: "discount") {
            value
          }
          media(first: 10) {
            nodes {
              ... on MediaImage {
                image {
                  url
                  altText
                  src
                }
              }
            }
          }
          onlineStoreUrl
          variants(first: 10) {
            nodes {
              id
              title
              availableForSale
              priceV2 {
                amount
                currencyCode
              }
              compareAtPriceV2 {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;

  const res = await fetch(PROD_GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': PROD_STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({ query, variables: { ids: gidIds } })
  });
  if (!res.ok) throw new Error(`Storefront API error (${res.status}): ${res.statusText}`);
  const { data, errors } = await res.json();
  if (errors) {
    console.error('GraphQL errors:', errors);
    return [];
  }
  return data.nodes
    .filter(node => node && node.variants.nodes.some(v => v.availableForSale))
    .slice(0, 6);
}
